<div class="main-page-wrapper p0 overflow-hidden">
    <div class="user-data-page clearfix d-lg-flex">
      <div class="illustration-wrapper d-flex align-items-center justify-content-between flex-column">
        <div class="illustration-holder">
          <img src="assets/images/assets/ils_11.svg" alt="" class="illustration">
        </div>
      </div> 
  
      <div class="form-wrapper">
        <form *ngIf="isMobileNum" ngNativeValidate #subForm="ngForm" (submit)="forget(subForm.value)" class="user-data-form mt-80 md-mt-40">
          <div class="row">
            <div class="col-12">
              <div class="input-group-meta mb-80 sm-mb-70">
                <label>Mobile*</label>
                <input required ngModel #mobile_no="ngModel" name="mobile_no" pattern="[5-9]{1}[0-9]{9}" type="text">
                <div class="error_text"  *ngIf="mobile_no.touched">
                  <p *ngIf="mobile_no.errors?.['required']">Mobile No is required.</p>
                  <p *ngIf="mobile_no.errors?.['pattern']">Please Enter Valid Mobile Number.</p>
                </div>
              </div>
            </div>
            <div class="col-6">
              <button type="submit" class="theme-btn-one mt-50 mb-50">Submit</button>
            </div>
            <div class="col-6">
              <button type="button" [routerLink]="['/register']" class="theme-btn-one mt-50 mb-50">Create New User</button>
            </div>
            
          </div>
        </form>

        <form  *ngIf="isverify" ngNativeValidate #verifyForm="ngForm" (submit)="verifyOtp(verifyForm.value)" class="user-data-form mt-80 md-mt-40">
            <div class="row">
              <div class="col-12">
                <h3 class="mobileNum">Please enter the OTP sent to your registered mobile number {{'xxxxxx' + (mobileNum | slice : -4)}}</h3>
              </div>
              <div class="col-12">
                <div class="input-group-meta mb-80 sm-mb-70">
                  <label>OTP</label>
                  <input required ngModel name="otp" type="number" >
                </div>
              </div>
    
              <div class="resend_otp"><a class="link" (click)="genrateOtp()" [ngClass]="counter == 0 ? '':'anchor_disable'" href="javascript:void(0)">Resend OTP</a>
    
                <div *ngIf="counter != 0" style="float: right">{{counter / 60 | number:'2.2-2' | slice:0:2}}  : {{counter % 60 | number:'2.0-0'}}</div></div>
        
        
              <div class="col-6">
                <!-- <button  type="button" (click)="genrateOtp()" class="theme-btn-one mt-50">Send Otp</button> -->
                <button type="submit" class="theme-btn-one mt-50">Verify</button>
    
              </div>
            </div>
          </form>

          <form *ngIf="isverifyed" ngNativeValidate #subForm="ngForm" (submit)="resetPassword(subForm.value)" class="user-data-form mt-80 md-mt-40">
            <div class="row">
              <div class="col-12">
                <div class="input-group-meta mb-80 sm-mb-70 disabled_input">
                  <label>Mobile*</label>
                  <input disabled ngModel [(ngModel)]="mobileNum" name="mobile_no" pattern="[8-9]{1}[0-9]{9}" type="text">
                </div>
              </div>

              <div class="col-12">
                <div class="input-group-meta mb-80 mb-15">
                  <label>New Password*</label>
                  <input required type="password" ngModel name="password"  #password="ngModel"
                 placeholder="Enter Password" class="pass_log_id">
                 <span class="error-text" *ngIf="password.errors?.['notMatch']">Password mismatch</span>
    
                </div>
              </div>
              <!-- <div class="col-12">
                <div class="input-group-meta mb-15">
                  <label>Confirm Password*</label>
                  <input required type="password" ngModel name="confirm_password" #confirm_password="ngModel"
                 placeholder="Enter Confirm Password" class="pass_log_id" (keyup)="confirmPass(subForm)">
                 <span class="error-text" *ngIf="confirm_password.errors?.['notMatch']">Password mismatch</span>
                </div>
              </div> -->
    
              <div class="col-4">
                <button type="submit" [disabled]="!subForm.valid" class="theme-btn-one mt-50 mb-50">Submit</button>
              </div>
              
            </div>
          </form>

      </div> <!-- /.form-wrapper -->
    </div>
  </div>
  